import APIService from "./APIService";

/**
 * Service for handling Payment and Subscription API operations
 *
 * Expected response format:
 * {
 *   "success": true/false,
 *   "message": "Descriptive message",
 *   "data": { ... }
 * }
 */
const PaymentAPI = {
  /**
   * Get payment information for a user
   * @param {string} userUuid - User UUID to get payment info for
   * @returns {Promise} Promise that resolves with payment data
   */
  getUserPayment: async (userUuid) => {
    try {
      const response = await APIService.get(
        `/api/v1/app/payment/user/${userUuid}`,
      );
      console.log(`[PaymentAPI] Get user payment response:`, response);
      return response;
    } catch (error) {
      console.error("[PaymentAPI] Error getting user payment:", error);
      throw error;
    }
  },
};

export default PaymentAPI;
